import type { Voucher } from '@src/domains/vouchers/types/voucher';
import { isVoucherPending } from '@src/domains/vouchers/core/isVoucherPending';

export interface VoucherSummary {
  total: number;
  hasMultiple: boolean;
  hasPending: boolean;
}

export function summarizeVouchers(vouchers: Voucher[]): VoucherSummary {
  return {
    total: vouchers.length,
    hasMultiple: vouchers.length > 1,
    hasPending: vouchers.length > 0 && vouchers.some(isVoucherPending),
  };
}
